import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

import { Helmet } from "react-helmet";

import "./home.css";

const Home = (props) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  let history = useHistory();
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setWindowWidth(window.innerWidth);
    });
  }, []);

  useEffect(async () => {
    if (windowWidth < 768) {
      await new Promise(r => setTimeout(r, 1000));
      window.scrollBy(0, 100);
    }
  }, [windowWidth]);

  return (
    <div className="home-container">
      <Helmet>
        <title>DeliBuddy</title>
        <meta property="og:title" content="DeliBuddy" />
      </Helmet>
      <header data-thq="thq-navbar" className="home-navbar-interactive">
        <img
          alt="logo"
          src="/playground_assets/untitled_artwork%20%5B6%5D%201%20%5B1%5D-1500w.png"
          loading="eager"
          className="home-logo"
        />
        <div
          data-thq="thq-navbar-nav"
          data-role="Nav"
          className="home-desktop-menu"
        >
          <nav
            data-thq="thq-navbar-nav-links"
            data-role="Nav"
            className="home-nav"
          >
            <span className="home-text">
              <a href="https://drive.google.com/drive/folders/1ARm4oiY51BHHg7OFPjD4-NzbIj6-siy0?usp=sharing" target="_blank">
                <span className="home-text01">Download</span>
              </a>
              <br></br>
            </span>
            <span className="home-text">
              <span className="home-text01" onClick={() => {
                document.querySelector('#contact-us').scrollIntoView({ behavior: 'smooth' })
              }}>Contact Us</span>
              <br></br>
            </span>
            <Link to="/account" id="login" className="home-navlink button">
              Login/Signup
            </Link>
          </nav>
        </div>
      </header>
      <div className="home-container02">
        <div className="home-delibuddy-services">
          <span className="home-text04">
            <span className="home-text05">Delivery</span>
            <span> at your doorstep,</span>
            <br></br>
            <span>made easy.</span>
          </span>
          <span className="home-text09">
            <span>Now get anything delivered to you at your hostel’s</span>
            <br></br>
            <span>in just a few clicks from our affiliated stores and</span>
            <br></br>
            <span>vendors</span>
          </span>
        </div>
        <img
          alt="image"
          src="/playground_assets/food.png"
          className="home-image2"
        />
      </div>
      <button
        type="button"
        autoFocus
        className="home-button button"
        onClick={() => {
          history.push("/account");
        }}
      >
        <span className="home-text15">
          <span>ORDER NOW!!</span>
          <br></br>
        </span>
      </button>
      <div className="home-container03">
        <div className="home-container04">
          <button className="home-download-app button" onClick={() => {
            window.open('https://drive.google.com/drive/folders/1ARm4oiY51BHHg7OFPjD4-NzbIj6-siy0?usp=sharing')
          }}>
            <span className="home-text18">
              <span>DOWNLOAD THE APP</span>
              <br></br>
            </span>
          </button>
          <span className="home-text21">
            <span className="home-text22">
              Download the mobile app for easier accessibility
            </span>
            <br></br>
          </span>
          <div className="home-container05">
            <div className="home-container06" onClick={() => {
              window.open('https://drive.google.com/drive/folders/1ARm4oiY51BHHg7OFPjD4-NzbIj6-siy0?usp=sharing')
            }}>
              <div className="home-container07">
                <svg viewBox="0 0 1024 1024" className="home-icon">
                  <path d="M640 214v-44h-42v44h42zM426 214v-44h-42v44h42zM662 92q106 76 106 206h-512q0-54 30-114t74-92l-56-56q-16-16 0-30t30 0l64 64q52-28 114-28 52 0 112 28l64-64q16-14 30 0t0 30zM874 342q26 0 45 19t19 45v298q0 28-19 46t-45 18-45-18-19-46v-298q0-26 19-45t45-19zM150 342q26 0 45 19t19 45v298q0 28-19 46t-45 18-45-18-19-46v-298q0-26 19-45t45-19zM256 768v-426h512v426q0 18-12 30t-30 12h-44v150q0 28-19 46t-45 18-45-18-19-46v-150h-84v150q0 28-19 46t-45 18-45-18-19-46v-150h-44q-18 0-30-12t-12-30z"></path>
                </svg>
              </div>
              <span className="home-text24">
                <span>Download for Android</span>
                <br></br>
              </span>
            </div>
            {/* <div className="home-container08">
              <img
                alt="image"
                src="/playground_assets/vector.svg"
                className="home-image3"
              />
              <span className="home-text27">
                <span>Download for Android</span>
                <br></br>
              </span>
            </div> */}
          </div>
        </div>
      </div>
      <div className="home-container09" id="contact-us">
        <div className="home-container10">
          <div className="home-container11">
            <div className="home-container12">
              <a href="tel:+918851956966" className="home-link">
                <div className="home-container13">
                  <svg viewBox="0 0 1024 1024" className="home-icon2">
                    <path d="M282 460q96 186 282 282l94-94q20-20 44-10 72 24 152 24 18 0 30 12t12 30v150q0 18-12 30t-30 12q-300 0-513-213t-213-513q0-18 12-30t30-12h150q18 0 30 12t12 30q0 80 24 152 8 26-10 44z"></path>
                  </svg>
                  <span className="home-text30">8851956966</span>
                </div>
              </a>
              <a
                href="mailto:delibuddy.in@gmail.com?subject="
                className="home-link1"
              >
                <div className="home-container14">
                  <svg viewBox="0 0 1024 1024" className="home-icon4">
                    <path d="M854 342v-86l-342 214-342-214v86l342 212zM854 170q34 0 59 26t25 60v512q0 34-25 60t-59 26h-684q-34 0-59-26t-25-60v-512q0-34 25-60t59-26h684z"></path>
                  </svg>
                  <span className="home-text31">delibuddy.in@gmail.com</span>
                </div>
              </a>
              <div className="home-container15">
                <img
                  alt="Vector9642"
                  src="/playground_assets/vector9642-djl.svg"
                  className="home-vector"
                />
                <span className="home-text32">
                  <span>Shiv Nadar University</span>
                  <br></br>
                  <span>Tehsil Dadri, Greater Noida</span>
                  <br></br>
                  <span>Uttar Pradesh, 201314.</span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="home-container16">
          <div className="home-container17">
            <a
              href="https://www.instagram.com/delibuddy.in/"
              target="_blank"
              rel="noreferrer noopener"
              className="home-link2"
            >
              <img
                alt="Vector9639"
                src="/playground_assets/vector9639-ci3.svg"
                className="home-vector1"
              />
            </a>
            <img
              alt="Vector9645"
              src="/playground_assets/vector9645-m8sq.svg"
              className="home-vector2"
            />
          </div>
        </div>
      </div>
      <div className="home-container18">
        <span className="home-text38">
          Copyright Delibuddy.in   All Rights Reserved
        </span>
      </div>
    </div>
  );
};

export default Home;
